import React from "react";

function ContactUs() {
  return (
    <main>
      {/* Breadcrumb Section */}
      <section className="page_breadcrumb" data-aos="fade-up">
        <div className="container">
          <div className="breadcrumb_content centred">
            <h1 className="breadcrumb_title">Contact Information</h1>
            <ul className="breadcrumb_menu">
              <li>
                <a href="/">Home</a>
              </li>
              <li>/</li>
              <li>Contact</li>
            </ul>
          </div>
        </div>
      </section>

      {/* Contact Info Section */}
      <section
        className="contact_info_section pt_150 pb_100"
        data-aos="fade-up"
      >
        <div className="container">
          <div className="section_title centred">
            <div className="tag_text">
              <h6>Get In Touch</h6>
            </div>
            <h2>Contact Eco Mantra Capital</h2>
          </div>
          <div className="row">
            <div
              className="col-xl-4 col-lg-4 col-md-6 col-sm-12"
              data-aos="fade-right"
            >
              <div className="contact_block_one mb_30">
                <div className="contact_block_icon">
                  <i class="fa-solid fa-phone-volume"></i>
                </div>
                <div className="contact_block_title">
                  <h4>Phone Number</h4>
                </div>
                <div className="contact_block_text">
                  <p>
                    <a href="tel:+919876543210">+91 98765 43210</a>
                  </p>
                </div>
              </div>
            </div>

            <div
              className="col-xl-4 col-lg-4 col-md-6 col-sm-12"
              data-aos="fade-up"
              data-aos-delay="200"
            >
              <div className="contact_block_one mb_30">
                <div className="contact_block_icon">
                  <i class="fa-solid fa-envelope"></i>
                </div>
                <div className="contact_block_title">
                  <h4>Email Address</h4>
                </div>
                <div className="contact_block_text">
                  <p>
                    <a href="mailto:support@ecomantracap.com">
                      support@ecomantracap.com
                    </a>
                  </p>
                </div>
              </div>
            </div>

            <div
              className="col-xl-4 col-lg-4 col-md-6 col-sm-12"
              data-aos="fade-left"
              data-aos-delay="400"
            >
              <div className="contact_block_one mb_30">
                <div className="contact_block_icon">
                  <i class="fa-solid fa-location-dot"></i>
                </div>
                <div className="contact_block_title">
                  <h4>Our Location</h4>
                </div>
                <div className="contact_block_text">
                  <p>Mumbai, Maharashtra, India</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Form Section */}
      <section className="contact_section pb_120" data-aos="fade-up">
        <div className="container">
          <div className="section_title centred">
            <h5>
              Fill out the form below and we'll get back to you within 24 hours
            </h5>
          </div>
          <form className="contact_form">
            <div className="row">
              <div className="col-xl-6 col-md-6 col-sm-12">
                <div className="form-group">
                  <input
                    type="text"
                    name="firstName"
                    placeholder="First name"
                  />
                </div>
              </div>
              <div className="col-xl-6 col-md-6 col-sm-12">
                <div className="form-group">
                  <input type="text" name="lastName" placeholder="Last name" />
                </div>
              </div>
              <div className="col-xl-6 col-md-6 col-sm-12">
                <div className="form-group">
                  <input type="email" name="email" placeholder="Your email" />
                </div>
              </div>
              <div className="col-xl-6 col-md-6 col-sm-12">
                <div className="form-group">
                  <input
                    type="text"
                    name="phone"
                    placeholder="Your Phone Number"
                  />
                </div>
              </div>
              <div className="col-xl-12 col-md-12 col-sm-12">
                <div className="form-group">
                  <input
                    type="text"
                    name="address"
                    placeholder="Enter Your Address"
                  />
                </div>
              </div>
              <div className="col-xl-12 col-md-12 col-sm-12">
                <div className="form-group">
                  <textarea
                    name="message"
                    placeholder="Tell us about your investment goals or any questions you have..."
                  ></textarea>
                </div>
              </div>
              <div className="col-xl-12 col-md-12 col-sm-12">
                <div className="form-group centred">
                  <button type="submit" className="btn_style_one">
                    Send Message
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </section>
    </main>
  );
}

export default ContactUs;
